export default {
    METAL_PANELS: 'metal-panels',
    FLAT_DECK: 'flat-deck',
    ASPHALT_SHINGLES: 'asphalt-fiberglass-shingles',
    CEDAR_SHINGLES: 'cedar-shingles',
    CEDAR_SHAKES: 'cedar-shakes',
    METAL_SHINGLES: 'metal-shingles',
    RUBBER_TILES: 'rubber-tiles',
    CONCRETE_TILES: 'concrete-tiles',
    CLAY_TILES: 'clay-tiles',
};
